/**
 * Created by sagardesai on 11/07/18.
 */

export const SEND_MESSAGE_REQUEST = "SEND_MESSAGE_REQUEST";
export const SEND_MESSAGE_RECEIVE = "SEND_MESSAGE_RECEIVE";
export const SEND_MESSAGE_FAILURE = "SEND_MESSAGE_FAILURE";
export const RESET_SEND_MESSAGE = "RESET_SEND_MESSAGE";

export const BLOCK_VIEWER_REQUEST = "BLOCK_VIEWER_REQUEST";
export const BLOCK_VIEWER_RECEIVE = "BLOCK_VIEWER_RECEIVE";
export const BLOCK_VIEWER_FAILURE = "BLOCK_VIEWER_FAILURE";
export const RESET_BLOCK_VIEWER = "RESET_BLOCK_VIEWER";

export const UNBLOCK_VIEWER_REQUEST = "UNBLOCK_VIEWER_REQUEST";
export const UNBLOCK_VIEWER_RECEIVE = "UNBLOCK_VIEWER_RECEIVE";
export const UNBLOCK_VIEWER_FAILURE = "UNBLOCK_VIEWER_FAILURE";
export const RESET_UNBLOCK_VIEWER = "RESET_UNBLOCK_VIEWER";

export const HIDE_MESSAGE_MODAL = "HIDE_MESSAGE_MODAL";
export const SHOW_MESSAGE_MODAL = "SHOW_MESSAGE_MODAL";